<template>
  <img :src="getImage" />
</template>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const props = defineProps<{
  name: string
}>()
const getImage = computed(() => {
  return `${runtimeConfig.public.app.staticCdnEndpoint}/assets/svg/${props.name}.svg`
})
</script>
